@if (!!item) {
<svg height="100%" width="100%" viewBox="-24.7 8 249.4 304"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="'cn-steel-' + item.id" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#b7bdc6"/>
      <stop offset="0.5" stop-color="#eef1f4"/>
      <stop offset="1" stop-color="#a7adb7"/>
    </linearGradient>
    <clipPath [attr.id]="'cn-clip-' + item.id">
      <path d="M68 52 L132 52 L140 85 L140 168 L100.8 264 L99.2 264 L60 168 L60 85 Z"/>
    </clipPath>
  </defs>

  <!-- Side legs + floor frame -->
  <g fill="#3a3d44">
    <rect x="58" y="182" width="6" height="112"/>
    <rect x="136" y="182" width="6" height="112"/>
    <rect x="52" y="294" width="18" height="4" rx="1"/>
    <rect x="130" y="294" width="18" height="4" rx="1"/>
    <rect x="64" y="278" width="72" height="5"/>
  </g>

  <!-- Liquid fill (clipped to the wide body + deep cone) -->
  <rect [attr.clip-path]="'url(#cn-clip-' + item.id + ')'" x="60" [attr.y]="y" [attr.height]="height" width="80" [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

  <!-- Wide body: chamfered flat top, straight walls, deep V cone (translucent so the level reads) -->
  <path d="M66 50 L134 50 L142 84 L142 170 L101 266 L99 266 L58 170 L58 84 Z" [attr.fill]="'url(#cn-steel-' + item.id + ')'" fill-opacity="0.42" stroke="#0f0f0f" stroke-width="1.5" stroke-linejoin="round"/>

  <!-- Two top ports / manways -->
  <rect x="76" y="36" width="20" height="14" rx="2" fill="#c9ced6" stroke="#7f8790" stroke-width="1.5"/>
  <rect x="104" y="36" width="20" height="14" rx="2" fill="#c9ced6" stroke="#7f8790" stroke-width="1.5"/>

  <!-- Bottom outlet + ball valve on the frame -->
  <rect x="97" y="266" width="6" height="10" fill="#c9ced6" stroke="#7f8790"/>
  <circle cx="100" cy="284" r="4.5" fill="#9aa0a8" stroke="#6f767f"/>

  <!-- Silhouette accents -->
  <path d="M58 84 L58 170 L99 266 M142 84 L142 170 L101 266" fill="none" stroke="#7f8790" stroke-width="1.2" stroke-linejoin="round" opacity="0.7"/>
</svg>
}
